<template>
    <div>
        <Pane title="重新提交服务报告" :showRemarks="false">
            <template>重新发起服务报告流程</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 8 }">
                <a-form
                    :form="form"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 16 }"
                    :colon="false"
                >
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="项目名称">
                                <a-input v-decorator="['projectName']" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="编号">
                                <a-input v-decorator="['serviceNo']" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="设计编号">
                                <a-input v-decorator="['designNo']" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="服务时间">
                                <a-date-picker
                                    v-decorator="['serviceDate']"
                                    style="width: 100%"
                                    placeholder="请选择服务时间"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="项目地点">
                                <a-input v-decorator="['projectAddress']" placeholder="请输入项目地点" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="服务人">
                                <EmployeeSelector
                                    :single="true"
                                    @change="handleServiceUserChange"
                                    :value="serviceUserList"
                                >
                                    <a-button block style="text-align: left">{{ serviceUserList.length ? serviceUserList[0].name : '请选择服务人' }}</a-button>
                                </EmployeeSelector>
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" label="服务内容或问题">
                                <a-textarea v-decorator="['serviceContent']" :rows="4" placeholder="请输入服务内容或问题" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" label="处理结果">
                                <a-textarea v-decorator="['handleResult']" :rows="3" placeholder="请输入处理结果" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" label="顾客验证">
                                <a-textarea v-decorator="['customerVerify']" :rows="3" placeholder="请输入顾客验证情况" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" label="备注">
                                <a-textarea v-decorator="['remark']" :rows="2" placeholder="请输入备注" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24" >
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" label="附件">
                                <Attachment :editable="true" :fileList="fileList" @change="fileList = $event" />
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import { fetchDesignServiceDetail, resubmitDesignService } from "@/api/project-execute/service-report";
import { mapMutations } from "vuex";
import EmployeeSelector from "@/components/employee-selector";
import Attachment from "@/components/attachment";
import { parseAttachment, buildAttachmentData } from '@/utils/attachment'
import moment from 'moment'

export default {
    name: "DesignServiceReapply",
    components: { EmployeeSelector, Attachment },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            submitting: false,
            id: "",
            phaseId: "",
            taskId: "",
            instanceId: "",
            serviceUserList: [],
            fileList: [],
        };
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.id = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.id) {
            this.fetchDetail(this.id);
        }
        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        fetchDetail(id) {
            this.loading = true;
            fetchDesignServiceDetail(id)
                .then((data) => {
                    if (!data) return;
                    this.phaseId = data.phaseId || "";
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.form.setFieldsValue({
                                projectName: data.projectName || "",
                                serviceNo: data.serviceNo || "",
                                designNo: data.designNo || "",
                                serviceDate: data.serviceDate ? moment(data.serviceDate) : undefined,
                                projectAddress: data.projectAddress || "",
                                serviceContent: data.serviceContent || "",
                                handleResult: data.handleResult || "",
                                customerVerify: data.customerVerify || "",
                                remark: data.remark || "",
                            });
                        });
                    });
                    if (data.serviceUserId && data.serviceUserName) {
                        this.serviceUserList = [{ id: data.serviceUserId, name: data.serviceUserName }];
                    }
                    this.fileList = parseAttachment(data.attachment, data.attachmentPaths)
                })
                .catch(() => {
                    // this.$message.error("获取服务报告详情失败");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleServiceUserChange(arr) {
            this.serviceUserList = arr.length ? arr : [];
        },
        submitReview() {
            this.form.validateFields((err, formValues) => {
                if (err) return;

                this.submitting = true;
                const attachmentData = buildAttachmentData(this.fileList);
                // 如果附件列表为空，则置空
                const finalAttachmentData = this.fileList.length > 0 ? attachmentData : { attachment: '', attachmentPaths: '' };

                const params = {
                    id: this.id,
                    phaseId: this.phaseId,
                    ...formValues,
                    ...finalAttachmentData,
                    serviceDate: formValues.serviceDate ? formValues.serviceDate.format('YYYY-MM-DD') : undefined,
                    serviceUserId: this.serviceUserList[0]?.id,
                    serviceUserName: this.serviceUserList[0]?.name,
                };

                resubmitDesignService(params)
                    .then(() => {
                        // this.$message.success("重新提交成功");
                        this.$close(this.$route.path, "/approval/task");
                    })
                    .catch((e) => {
                        console.error("提交失败详情", e);
                        // this.$message.error("提交失败");
                    })
                    .finally(() => {
                        this.submitting = false;
                    });
            });
        },
        goBack() {
            this.$close(this.$route.path);
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}
</style>
